export default {
  uploads: [],
  upload: {},
  read: {},
  files: [],
  posts: [],
  uploadsByKeywords: [],
  isLoading: false
};
